import React, { useState } from 'react'

const ATestPage = () => {
  // State to keep track of the dropped box
  const [dropped, setDropped] = useState(false)

  // Drag start handler
  const handleDragStart = (e) => {
    e.dataTransfer.setData('text/plain', e.target.id)
  }

  // Drop handler
  const handleDrop = (e) => {
    e.preventDefault()
    const id = e.dataTransfer.getData('text/plain')
    const droppedElement = document.getElementById(id)
    droppedElement.style.position = 'absolute'
    droppedElement.style.left = `${e.clientX - 50}px` // Adjust for offset
    droppedElement.style.top = `${e.clientY - 50}px` // Adjust for offset
    setDropped(true)
  }

  // Drag over handler to allow drop
  const handleDragOver = (e) => {
    e.preventDefault()
  }

  return (
    <div>
      <h2>Drag and Drop Example</h2>
      <div
        id="dragBox"
        draggable
        onDragStart={handleDragStart}
        style={{
          width: '100px',
          height: '100px',
          backgroundColor: 'skyblue',
          textAlign: 'center',
          lineHeight: '100px',
          cursor: 'move',
          marginBottom: '20px',
        }}
      >
        Drag Me
      </div>

      <div
        id="dropZone"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        style={{
          width: '500px',
          height: '400px',
          backgroundColor: '#f0f0f0',
          border: '2px dashed #ccc',
          position: 'relative',
        }}
      >
        {dropped && <p>Box Dropped!</p>}
      </div>
    </div>
  )
}

export default ATestPage
